module.exports = __webpack_public_path__ + "img/providenciales.8fbcf7f0.jpg";